import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

// Configure dayjs to work properly with Ant Design
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const CustomDatePicker = ({ 
  value, 
  onChange, 
  format = "YYYY-MM-DD", 
  style = { width: '100%' }, 
  placeholder = "Select Date",
  allowClear = true,
  showToday = true,
  disabledDate = (current) => current && current > dayjs().endOf('day'),
  ...props 
}) => {
  // Ensure the value is always a valid dayjs object
  const safeValue = value && dayjs.isDayjs(value) ? value : undefined;
  
  return (
    <DatePicker
      value={safeValue}
      onChange={onChange}
      format={format}
      style={style}
      placeholder={placeholder}
      allowClear={allowClear}
      showNow={showToday}
      disabledDate={disabledDate}
      // Additional props to prevent year jumping
      inputReadOnly={false}
      autoFocus={false}
      // Additional props for better dayjs compatibility
      showTime={false}
      {...props}
    />
  );
};

export default CustomDatePicker;
